export enum TipoPessoa {
  FISICA = 'FISICA',
  JURIDICA = 'JURIDICA'
  }
  